/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import DownloadDocumentPricingIndividualHealthMutation from '../graphql/mutations/DownloadDocumentPricingIndividualHealthMutation.js';

export const useDownloadDocumentPricingIndividualHealthMutation = () => {
  return useCommitMutation(DownloadDocumentPricingIndividualHealthMutation, { dataProp: 'downloadDocumentPricingIndividualHealth_M_simulation_pricings_individual_health' });
};

export default useDownloadDocumentPricingIndividualHealthMutation;
